module.exports = __webpack_public_path__ + "img/remove.f83b2e0d.svg";